/*
产品管理工厂
2017-12-5
 */
"use strict";
angular.module("agreementServiceModule", [
    "agreementModule" //协议
]).
factory("agreementService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [agreement description] 协议
         * @param {[string]} [content] [description] 内容
         */
        agreement: function(content) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./login/register/service/agreement/agreement_tpl.html",
                windowClass: 'agreement',
                backdrop: false,
                controller: "agreementCtrl",
                resolve: {
                    content: function() {
                        return content;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);